{
  "emptyState": "Aucune approbation FAA en attente",
  "unknown": "Inconnu",
  "headers": {
    "tailNumber": "Immatriculation",
    "aircraftType": "Type d'aéronef",
    "fbo": "FBO",
    "submittedBy": "Envoyé par",
    "submitted": "Envoyé",
    "tenant": "Locataire",
    "actions": "Actions"
  },
  "tenant": {
    "created": "Créé",
    "noTenant": "Aucun tenant"
  },
  "errors": {
    "missingData": "Impossible d'approuver : données de l'aéronef manquantes. Essayez d'actualiser.",
    "createFaaTail": "Échec de la création de l'immatriculation FAA : {{message}}",
    "createFaaMapping": "Échec de la création du mapping FAA : {{message}}",
    "markApproved": "Échec de l'approbation : {{message}}",
    "approveFailed": "Échec de l'approbation. Veuillez réessayer.",
    "rejectFailed": "Échec du rejet. Veuillez réessayer."
  },
  "success": {
    "approved": "Correspondance FAA approuvée pour {{tailNumber}} → {{make}} {{model}}",
    "rejected": "Demande d'approbation refusée pour {{tailNumber}}"
  }
}
